import { render, staticRenderFns } from "./ShowTeachers.vue?vue&type=template&id=967585d8&scoped=true&"
import script from "./ShowTeachers.vue?vue&type=script&lang=js&"
export * from "./ShowTeachers.vue?vue&type=script&lang=js&"
import style0 from "./ShowTeachers.vue?vue&type=style&index=0&id=967585d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967585d8",
  null
  
)

export default component.exports